module.exports = __webpack_public_path__ + "static/img/1.f376f96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/1.png
// module id = Ogm5
// module chunks = 0